import { BYO_OPEN_MODAL, BYO_CLOSE_MODAL, BYO_OPENING_FROM_CAMPAIGN, LINEUPS_OPEN_MODAL, LINEUPS_CLOSE_MODAL } from '../constants';
const initialState = {
    isModalOpen: false,
    isLineupsModalOpen: false,
    isOpeningFromCampaign: false,
};
//eslint-disable-next-line complexity
const appReducer = (state = initialState, action = { type: '', payload: '' }) => {
    if (!action) {
        return state;
    }
    if (action.type === BYO_OPEN_MODAL) {
        return Object.assign(Object.assign({}, state), { isModalOpen: true });
    }
    if (action.type === BYO_CLOSE_MODAL) {
        return Object.assign(Object.assign({}, state), { isModalOpen: false });
    }
    if (action.type === BYO_OPENING_FROM_CAMPAIGN) {
        return Object.assign(Object.assign({}, state), { isOpeningFromCampaign: action.payload });
    }
    if (action.type === LINEUPS_OPEN_MODAL) {
        return Object.assign(Object.assign({}, state), { isLineupsModalOpen: true });
    }
    if (action.type === LINEUPS_CLOSE_MODAL) {
        return Object.assign(Object.assign({}, state), { isLineupsModalOpen: false });
    }
    return state;
};
export default appReducer;
